export const percentFormat = '.1~%';
export const numericFormat = ',.1~f';
export const numericCurrFormat = '$,.1~f';
